/**
 * Milestones (seconds remaining) at which the exam clock is announced to screen readers.
 * The visible clock itself is never read out every second; a separate polite live region
 * announces only these moments: start, 30 / 15 / 10 / 5 / 1 minute(s), 30 seconds, and the end.
 */
export const TIMER_MILESTONES_SECONDS: number[] = [1800, 900, 600, 300, 60, 30];

/** Whole seconds left, rounded up like the visible clock. */
export function remainingSeconds(remainingMs: number): number {
  return remainingMs <= 0 ? 0 : Math.ceil(remainingMs / 1000);
}

/**
 * The smallest milestone that has been reached (remaining <= milestone) and was not yet
 * announced, or null. If several were crossed at once (e.g. a throttled background tab)
 * only the latest one is returned, so the user hears a single, current message.
 */
export function reachedMilestone(remainingMs: number, announced: number[]): number | null {
  if (remainingMs <= 0) {
    return null;
  }
  const seconds = remainingSeconds(remainingMs);
  const open = TIMER_MILESTONES_SECONDS.filter(m => seconds <= m && announced.indexOf(m) === -1);
  return open.length ? Math.min.apply(null, open) : null;
}

/** All milestones that are already behind us (used when the exam is opened or resumed). */
export function milestonesPassed(remainingMs: number): number[] {
  const seconds = remainingSeconds(remainingMs);
  return TIMER_MILESTONES_SECONDS.filter(m => seconds <= m);
}
